<template>
  <div class="cx_reportTemplate">
    <ListView
      modelName="ReportTemplate"
      perm="system.menu_report_template"
      :items.sync="items"
      :params.sync="params"
      title="menu_report_template"
      :key="$route.fullPath"
      :sortOptions="sortOptions"
      ref="mainList"
      :tabs="['基本情報']"
      gridKey="reportTemplate"
      :gridCaptions="['状態','ワークフロー','ID', '表示画面', '帳票タイプ', '帳票名']"
      :gridWidths="[100,120, 200, 200, 200, 200]"
    :comparer="(a,b)=>a.id == b.id"              
    tooltip="各伝票の一覧画面から出力される帳票と管理帳票のテンプレートを登録します。1つの【帳票テンプレート】に複数の【帳票ページレイアウト】を関連付けることができます。(例)「納品書 兼 検収書」<br><br>※一部の帳票タイプはメール送信に対応しており、【メール設定】タブで詳細を登録することができます。"  
      :popup="popup"
      @selected="onSelected"
    >
      <!-- 明細項目の配置 -->
       <GridItem slot="grid0" slot-scope="{ item }" ><Badge :value="item.state" list="approvalStatus"/></GridItem>      
      <GridItem slot="grid1" slot-scope="{ item, index }" ><Workflow :item="item" :index="index" @updated="onWorkflow"/></GridItem>             
      <GridItem slot="grid2" slot-scope="{ item }">{{ item.id }}</GridItem>
      <GridItem slot="grid3" slot-scope="{ item }">{{ $translate(item.viewName) }}</GridItem>
      <GridItem slot="grid4" slot-scope="{ item }">{{ item.controllerName }}</GridItem>
      <GridItem slot="grid5" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.reportName }}</GridItem>
      <!-- リストメニューの配置 -->
      <template slot="menu" slot-scope="{ listView }">
        <ListViewMenuBar :listView="listView">
            <ListViewMenu title="システム帳票の初期化" @click="onResetSystemTemplate" perm="system"/>          
          </ListViewMenuBar>
      </template>
      <!-- 検索パネルーの配置 -->
      <template slot="search" slot-scope="{ params, handler, listView }">
        <Search :listView="listView">
          <!-- <FilterBox title="ID" :value.sync="params.id" placeholder="Enter ID" @click="handler" /> -->
          <FilterBox title="帳票名" :value.sync="params.reportName" placeholder="Enter Report Name" @click="handler" />
          <!-- <FilterBox title="表示画面" :value.sync="params.viewName" placeholder="Enter List Name" @click="handler" /> -->
        　<ComboBox title="表示画面" :value.sync="params.viewName" list="viewNamesReportTemplate" @changed="handler" />          
           <ComboBox title="状態" :value.sync="params.state" list="approvalStatus" @changed="handler"/>                            
        </Search>
      </template>
      <!-- エディタの配置 -->
      <template slot="sideEditor" slot-scope="{ listView }">
        <Editor :item="listView.selected" :owner="listView" :tabs="tabs(listView.selected)"   :tabVisibles="tabVisibles(listView.selected)" :tabTooltips="[null,null]">
          <template slot="menu" slot-scope="{item,editor}">
            <Button class="button" @click="onMoveToLayouts" caption="レイアウト表示" :disabled="editor.isEdit" tooltip="選択した帳票テンプレートに紐づいている、帳票ページレイアウトを表示します。" />
            <SplitButton class="button" @click="onUploadFile" caption="ファイルアップロード" :disabled="editor.isEdit || item.state ==  approvalStates.Approved"  perm="system" tooltip="ここから帳票テンプレートのエクセルファイルをアップロードします。状態が【公開待ち】になっている帳票のみアップロード可能です。" >
            <Button2 class="button" @click="showPreviewDialog(item)" caption="帳票プレビュー" :disabled="!item.fileName || editor.isEdit || item.viewName == 'menu_reports'"  perm="system" tooltip="" />
            </SplitButton>
          </template>
          <template slot="tab0" slot-scope="{ editor, item }">
            <EditPanel>
              <template slot="left">
                <!-- <div style="display:flex;justify-content:flex-end;margin-bottom:10px;">
                </div> -->
                <NumericBox title="ID" :value.sync="item.id" :editor="editor" :enabled="false" tooltip="初回保存時に番号が自動で付与されます。この番号は手動で変更することができません。" />
                <RadioButton title="帳票区分" :value.sync="item.isSystemOwned" :editor="editor" list="reportSystemOwnedFlags" :enabled="false" tooltip="システム帳票とユーザー帳票の２種類があります。追加した帳票やシステム帳票を編集した際はユーザー帳票として登録されます。" />
                <AutoComplete title="帳票タイプ" :value.sync="item.controller" :required="true" query="LayoutControllerQuery" :editor="editor" tooltip="登録する帳票のタイプを選択します。管理帳票または出力する画面の管理カテゴリの中から選択します。" />
                <TextBox title="帳票名" :editor="editor" :value.sync="item.reportName" length="50" required="true" placeholder="Enter Name" tooltip="最大50文字までの､登録する帳票の名前を入力します。" />
                <ComboBox title="言語設定" :value.sync="item.locale" list="locale" :required="true" :editor="editor" v-if="langEnabled" />
                <Control title="ファイル名" :isEdit="false" :enabled="false" tooltip="アップロードしたエクセルのファイル名が表示されます。ファイル名が拡張子込みで50文字までのファイルを登録することができます。" >
                  <a slot="read" @click.prevent="onDownload(item.id)" href="javascript:void(0)">{{ item.fileName }}</a>
                </Control>
                <TextBox title="ファイル更新日時" :value="$api.formatter.formatTimeStamp(item.fileTimeStamp)" :enabled="false" tooltip="アップロードしたテンプレートのエクセルファイルの最終更新日時が表示されます。" />
                <TextBox title="アップロード日時" :value="$api.formatter.formatTimeStamp(item.uploadTimeStamp)" :enabled="false" tooltip="テンプレートのエクセルファイルをアップロードした日時が表示されます。" />
              </template>
              <template slot="right"> 
              <CheckBox title="用紙サイズ" :value.sync="item.useCustomPaperSize" list="useCustomPaperSizeFlags" :editor="editor" :isDirectEditEnabled="false" @changed="onCustomPaperSizeChanged()" tooltip="エクセルのページ設定で、独自の印刷用紙を利用している場合チェックを入れて用紙サイズを指定できます。（A4などの一般的な用紙の場合はチェック不要です。）" />
              <NumericBox title="幅(ミリ単位)" :value.sync="item.customPaperSizeWidth" :editor="editor" :required="item.useCustomPaperSize" :enabled="item.useCustomPaperSize" :decimals="2" :min="0" :max="999.99" tooltip="ユーザー定義用紙の横のサイズをミリメートル単位で指定します。" />
              <NumericBox title="高さ(ミリ単位)" :value.sync="item.customPaperSizeHeight" :editor="editor" :required="item.useCustomPaperSize" :enabled="item.useCustomPaperSize" :decimals="2" :min="0" :max="999.99" tooltip="ユーザー定義用紙の縦のサイズをミリメートル単位で指定します。" />
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="選択した帳票テンプレートデータを最後に更新した日時が表示されます。" />
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_approval" :required="$api.perms.hasWorkflow('approval')" :enabled="$api.perms.hasWorkflow('approval') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="システム設定用のワークフローを指定します。【フロー区分】が【システム管理】になっているデータから選択ができます。" />
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="帳票テンプレートデータの現在の状態が表示されており､ワークフロー欄の確定や使用停止ボタンをクリックすることで変化します。" />
              </template>
            </EditPanel>
          </template>
          <template slot="tab1" slot-scope="{ editor, item }">
            <EditPanel>
              <template slot="left">            
              <CheckBox title="メール送信許可" :value.sync="item.isSendThisReport" list="isSendThisReport" :editor="editor" :isDirectEditEnabled="false"   tooltip="この帳票をメールで送信するかを指定します。一覧メニューとワークフロー進行時にメール送信が可能です。<br>※テナント設定の【帳票メール送信方法】で一覧メニューでの送信を不可にできます。" />                
              <TextBox title="タイトル" :value.sync="item.mailSubject" :editor="editor" :enabled="item.sendMail" :required="item.sendMail"  length="100" tooltip="送信するメールのタイトルを最大100文字まで入力できます。設定の方法、プレースホルダについては<a href='https://support.s-flow.net/ja/articles/8259489#h_aa53ba94dd' target='_blank'>こちら</a>をご確認ください。" />     
              </template>
              <template slot="right">
              <TextBox title="メール文面" :value.sync="item.mailBody" :editor="editor" :enabled="item.sendMail"  :required="item.sendMail"  length="1000" rows="12" tooltip="送信するメールのタイトルを最大1000文字まで入力できます。設定の方法、プレースホルダについては<a href='https://support.s-flow.net/ja/articles/8259489#h_aa53ba94dd' target='_blank'>こちら</a>をご確認ください。"/>                     
              </template>
            </EditPanel>
          </template>          
        </Editor>
        <!-- プレビュー画面 -->
        <ListDialog ref="reportPreview" title="帳票プレビュー" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" >
          <template slot="header" slot-scope="{ editor }">
            <AutoComplete :editor="editor" :title="previewItem.viewName=='menu_stock_balance' ? '在庫':'伝票番号'" :required="true" :value.sync="previewVoucherNo" :provider="cmbPreviewVoucherNoQuery" tooltip="帳票プレビューを表示する伝票を指定します。伝票が登録されていない場合は表示されません。" />
          </template>
        </ListDialog>
      </template>
    </ListView>
    <b-modal v-model="showUpload" title="テンプレートファイル" @ok="onAdd" :no-close-on-backdrop="true" centered v-if="showUpload">
      <input type="file" id="filename" name="files" ref="file" size="100" multiple="multiple" @input="onInput" />
      <div class="cx_control_validation" v-if="uploadFileValidation">{{ uploadFileValidation }}</div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class ReportTemplateVue extends Vue {
  public items: Common.ReportTemplate[] = new Array();
  public params: Common.ReportTemplateQuery = new Common.ReportTemplateQuery();
  public approvalStates = Common.ApprovalStatus;
  public langEnabled : boolean = false;
  public previewItem: Common.ReportTemplate = null;
  public previewVoucherNo:any = null;
  @Prop() public id:number;
  @Prop({default:null}) public popup: Components.PopupEditor;

  public created(){
    if(this.id) this.params.id = this.id;
    this.params.state = null;
    // ライセンスによって表示項目を制御する
    this.langEnabled  = this.$api.hasLicense(Common.licenseFlags.currency);
  }
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'viewName', text: '表示画面' },
    { value: 'reportName', text: '帳票名' },
  ];
  showUpload: boolean = false;
  uploadFileValidation: string = null;

  public tabs(obj: Common.ReportTemplate) {
    return obj != null && obj.controller && obj.controller.supportMail  ? ['基本情報','メール設定'] :['基本情報']
  }
  public  tabVisibles(obj: Common.ReportTemplate){
    // if (!this.$refs.mainList) return [true,false]; //フォールバック。エラー放置すると$refsへの反映が遅延してしまう
    // const obj = (this.$refs.mainList as Components.ListView).selected as Common.ReportTemplate;
    return obj != null && obj.controller && obj.controller.supportMail ?  [true,true] :[true,false];
  }
  public onMoveToLayouts() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.ReportTemplate;
    this.$router.push('/system/ReportLayout?templateId=' + obj.id);
  }

  onCustomPaperSizeChanged() { 
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.ReportTemplate;
    if(obj.useCustomPaperSize==false){
      obj.customPaperSizeWidth=0;
      obj.customPaperSizeHeight=0;
    }
  }
  public onUploadFile() {
    this.showUpload = true;
  }

  public showPreviewDialog(item: Common.ReportTemplate){
    if(this.previewItem != item){
      this.previewItem = item;
      this.previewVoucherNo = null;
    }
    (this.$refs.reportPreview as Components.ListDialog).showDialog();
  }

  public onDownload(templateId: number) {
    if (templateId == 0) return;
    const query = new Common.ReportTemplateDownloadQuery(templateId);
    this.$api.download(query);
  }
  public onInput() {
    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) {
      this.uploadFileValidation = 'ファイルを選択してください。';
    } else if (obj[0].name.length > 50) {
      this.uploadFileValidation = '登録可能なファイル名は最大50桁です。';
    } else {
      this.uploadFileValidation = null;
    }
  }
  public onAdd(args: any) {
    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) {
      this.uploadFileValidation = 'ファイルを選択してください。';
      args.preventDefault();
      return;
    } else if (obj[0].name.length > 50) {
      this.uploadFileValidation = '登録可能なファイル名は最大50桁です。';
      args.preventDefault();
      return;
    } else {
      const size = Array.from(obj).reduce((sum, file) => sum + file.size, 0);
      // lambda実行の場合最大サイズを4.4MBとする
      if(this.$api.license.isLambda == true && size > this.$api.fileMaxSizeByte){
          this.$api.modal.show('', String.format("インポートやファイル添付で使用できるファイルサイズは{0}MBまでです。ファイルサイズを減らして再度お試しください。", this.$api.fileMaxSizeMB), true, null);      
          return;
        }
      this.uploadFileValidation = null;
    }

    const query = new Common.ReportTemplateUploadQuery();
    query.templateId = (this.$refs.mainList as Components.ListView).selected.id;
    query.timestamp = new Date(obj[0].lastModified).toISOString();

    var selectedId = (this.$refs.mainList as Components.ListView).selectedId();
    this.$api.upload(query, obj).then(response => {
      this.$set(this.items, selectedId, response);
    });
  }

  public onResetSystemTemplate() {
    this.$api.modal.showDialog('確認メッセージ','システム帳票を全て削除し、最新バージョンで初期化します。よろしいですか？',false).then(()=>{
      this.$api.execute(new Common.ReportTemplateResetQuery()).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','初期化処理が開始されました。\r\n実行結果は、以下のリンクから確認できます。',true,null,links);          
      });
    });
  }  
  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }    

  public onSelected(index: number, item: Common.ReportTemplate) {
    item.isSentFromClient = true; // ユーザー側からのデータの送信の際はユーザー帳票に変えるためのフラグ
  }
  public async cmbPreviewVoucherNoQuery():Promise<Common.BindItem[]> {
    var bindItems = new Array();
    var query = new Common.PreviewVoucherNoQuery(this.previewItem.viewName);
    await this.$api.execute(query).then(res => {
        var result = res as Common.LoadResult;
        result.result.forEach(obj =>{
          bindItems.push(new Common.BindItem(obj.value,obj.name));
        });
      });
    return Promise.resolve(bindItems);
  }
  public async onReportGenerate() {
    let template = (this.$refs.mainList as Components.ListView).selected as Common.ReportTemplate;
    let viewname = '';
    let key = null;
    key = this.previewVoucherNo;
    switch(template.viewName){
      case "menu_purchase_order" : 
      case "menu_sales_order" : 
        viewname='Order';
        break;
      case "menu_purchase_delivery" : 
      case "menu_sales_delivery" : 
        viewname='Delivery';
        break;
      case "menu_invoice" : 
        viewname='Invoice';
        key = Number(this.previewVoucherNo);
        break;
      case "menu_purchase_charge" : 
      case "menu_sales_charge" : 
        viewname='Charge';
        break;
      case "menu_receive_payment" : 
      case "menu_send_payment" : 
        viewname='Payment';
        break;
      case "menu_picking" : 
        viewname='Picking';
        break;
      case "menu_stock_balance" : 
        viewname='StockBalance';
        break;
      case "menu_stock_relocation" : 
        viewname='StockRelocation';
        break;
      case "menu_stock_taking" : 
        viewname='StockTaking';
        break;
      case "menu_stock_transfer" : 
        viewname='StockTransfer';
        break;
      case "menu_project_item" : 
        viewname='ProjectItem';
        break;
    }
    this.$api.find(viewname, [key]).then(res => {
      var query = new Common.ReportQuery2(template.queryName, [res]);
      query.templateId = template.id;
      query.onExcelFormat = false;
      this.$api.download(query);
    });
  }
}

</script>
<style lang="scss">
.cx_reportTemplate {
  /* 縦配置のフィル */
  flex: 1;
  /* 初期状態でオーバーフローするとflexが崩れるため下限値を0にしておく*/
  min-height: 0px;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  overflow-x: hidden;
}

.cx_taskbutton {
  font-size: 14px;
  height: 28px;
  padding: 2px 7px;
  outline: 0 !important;
  box-shadow: none;
  margin: -3px 0px 0px 10px;
  // min-width:120px;
}
.cx_control_validation {
  font-size: 7pt;
  margin-top: 0px;
  color: red;
}
</style>
